export interface PlacementContent {
  content: any
  callbacks: CallbackSet
  callbackData: string
  visitorId: string
}

export type CallbackSet = {
  impression: string
  clickthrough: string
}

export enum CallbackSetEvent {
  IMPRESSION = 'IMPRESSION',
  CLICK_THROUGH = 'CLICKTHROUGH',
}

export interface PlacementContentArgs {
  mode: Mode
  placementId: string
  implementationId?: string
  previewOptions?: PreviewOptions
  attributes: Attributes
  resolveVisitorState: boolean
  recsPreFilter: boolean
}

export enum Mode {
  PREVIEW = 'PREVIEW',
  SAMPLE = 'SAMPLE',
  LIVE = 'LIVE',
  NULL = 'NULL',
}

export enum MultiVariantGroup {
  TEST = 'TEST',
  BASELINE = 'BASELINE',
}

export type Attributes = {
  visitor?: Visitor
  user?: User | {}
  view?: View
  product?: QubitProduct
  listingProducts?: QubitProduct[]
  basketProducts?: QubitProduct[]
  transactionProducts?: QubitProduct[]
}

type Visitor = {
  id: string
  viewNumber?: number
  sessionNumber?: number
  entranceNumber?: number
  sessionViewNumber?: number
  conversionNumber?: number
  lifetimeValue?: number
  firstViewTs?: number
  lastViewTs?: number
  firstConversionTs?: number
  lastConversionTs?: number
  ipAddress?: string
  url?: string
  userAgent?: UserAgent
  location?: Location
}

type QubitProduct = {
  id?: string
  name?: string
  categories?: string[]
}

type UserAgent = {
  browserName: string
  browserVersion: string
  deviceName: string
  deviceType: string
  osName: string
  osVersion: string
  userAgent: string
}

type User = {
  id: string
  email: string
  loyalty: Loyalty
}

type Location = {
  areaCode: string
  cityCode: string
  regionCode: string
  countryCode: string
}

type Loyalty = {
  membershipType: string
}

type View = {
  currency: string
  type: string
  subtypes: string[]
  language: string
}

export enum QubitViewType {
  PRODUCT = 'product',
  CATEGORY = 'category',
  HOME = 'home',
  BASKET = 'basket',
  SEARCH = 'search',
}

type PreviewOptions = {
  campaignId: string
  experienceId: string
  demoMode: boolean
  group: MultiVariantGroup
}
